import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  align: 'center',
})`
  width: 100%;
  margin-bottom: 10px;

  & > div {
    width: 100%;
  }
`;
